export default __webpack_public_path__ + "static/media/PRlogo.21d8268e.svg";